export default "/images/vendor/flag-icons/flags/4x3/cm.svg?7eff011cd2036bfc5df42647682d9402";